import * as React from "react"
import colors from "@digits-shared/themes/colors"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"
import { SearchPageContainer } from "src/frontend/components/OS/Applications/Search/shared"

const Marketing = styled.div`
  text-align: center;
  width: unset;
  margin: max(200px, 25vh) auto;
  font-weight: ${fonts.weight.normal};
  pointer-events: none;
`

const MarketingTitle = styled.div`
  color: ${colors.translucentSecondary80};
  font-size: 22px;

  b {
    color: ${colors.secondary};
    font-weight: ${fonts.weight.heavy};
  }
`

const Text = styled.div`
  color: ${colors.translucentSecondary70};
  font-size: 16px;
  margin: 10px 0 20px;
`

/*
  INTERFACES
*/

interface SearchMarketingProps {
  hide: boolean
}

/*
  COMPONENTS
*/

export const SearchMarketing: React.FC<SearchMarketingProps> = ({ hide }) => (
  <>
    {!hide && (
      <SearchPageContainer>
        <Marketing>
          <MarketingTitle>
            Search your entire financial history. <b>Instantly.</b>
          </MarketingTitle>
          <Text>
            Digits puts all of your vendors, transactions,
            <br /> and more at your fingertips.
          </Text>
        </Marketing>
      </SearchPageContainer>
    )}
  </>
)
